import Icon from "./IconBase.js";
const UploadFileIcon = (props) => {
  return (
    <Icon width="50" height="50" viewBox="0 0 80 70" {...props}>
      <svg
        width="73"
        height="72"
        viewBox="0 0 73 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.3986 38.67C43.26 39.54 44.6561 39.54 45.5175 38.67C46.4085 37.8 46.4085 36.39 45.5472 35.52L37.0224 26.88C36.8145 26.67 36.5769 26.52 36.3095 26.4C36.0422 26.28 35.7749 26.22 35.4779 26.22C35.1808 26.22 34.8838 26.28 34.6165 26.4C34.3491 26.52 34.1115 26.67 33.9036 26.88L25.4085 35.52C24.5472 36.39 24.5472 37.8 25.4085 38.67C26.2699 39.54 27.666 39.54 28.5274 38.67L33.2501 33.87V48.36C33.2501 49.59 34.2303 50.58 35.4779 50.58C36.6957 50.58 37.6759 49.59 37.6759 48.36V33.87L42.3986 38.67ZM58.5465 27.0768C59.2447 27.0688 60.0049 27.06 60.6957 27.06C61.4382 27.06 62.062 27.66 62.062 28.41V52.53C62.062 59.97 56.062 66 48.6957 66H25.0818C17.3293 66 11.062 59.67 11.062 51.87V19.53C11.062 12.09 17.0323 6 24.4581 6H40.3194C41.062 6 41.6858 6.63 41.6858 7.38V17.04C41.6858 22.53 46.1412 27.03 51.6066 27.06C52.8559 27.06 53.9651 27.0694 54.9394 27.0777C55.7024 27.0842 56.3827 27.09 56.9828 27.09C57.4056 27.09 57.9537 27.0837 58.5465 27.0768ZM59.376 22.698C56.9344 22.707 54.0591 22.698 51.9888 22.677C48.7037 22.677 45.9978 19.944 45.9978 16.626V8.718C45.9978 7.425 47.5482 6.783 48.4364 7.716C50.7252 10.1174 54.2297 13.7984 57.1904 16.9083C58.3871 18.1652 59.4949 19.3289 60.3978 20.277C61.2621 21.186 60.6265 22.695 59.376 22.698Z"
          fill="#00B0F5"
        />
      </svg>
    </Icon>
  );
};
export default UploadFileIcon;
